/* import __COLOCATED_TEMPLATE__ from './title.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { type LocalizedKnowledgeContent } from 'embercom/objects/knowledge-hub/localized-knowledge-content';
import type IntlService from 'ember-intl/services/intl';
import { EntityType } from 'embercom/models/data/entity-types';

interface Args {
  activeContent: LocalizedKnowledgeContent;
}

export default class Editor extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare intl: IntlService;

  get app(): $TSFixMe {
    return this.appService.app;
  }

  get entityType() {
    return this.args.activeContent.entityType;
  }

  get typeTitle() {
    if (this.args.activeContent.defaultTitle) {
      return this.args.activeContent.defaultTitle;
    }

    // Use standalone translations for EntityType.ArticleContent (120) when in standalone mode
    if (this.app.canUseStandalone && this.entityType === EntityType.ArticleContent) {
      return this.intl.t(`knowledge-hub.content-type-stamp.standalone.${this.entityType}`);
    }

    return this.intl.t(`knowledge-hub.content-type-stamp.content-type.${this.entityType}`);
  }

  get currentTitle() {
    if (
      this.args.activeContent.latestVersion?.versionTitle === this.args.activeContent.defaultTitle
    ) {
      return '';
    }
    return this.args.activeContent.latestVersion?.versionTitle;
  }

  set currentTitle(value: string | undefined) {
    if (!this.args.activeContent.latestVersion) {
      return;
    }
    this.args.activeContent.latestVersion.versionTitle = value;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Shared::Edit::Title': typeof Editor;
    'knowledge-hub/content-editor/shared/edit/title': typeof Editor;
  }
}
